var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstudiante10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 94,
    viewBox: "0 0 57 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59998 73.57L19.72 62.94V32.56L1.59998 43.19V73.57Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390015 44.29L1.60001 44.98V73.57L0.390015 72.98V44.29Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.58 71.04L39.54 61.18V41.91L22.58 51.77V71.04Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 82.75L56.61 72.89V53.62L39.65 63.48V82.75Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 51.7L39.54 41.84L22.58 51.7L39.65 61.56L56.61 51.7Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.14 25.94C47.7866 25.0572 47.2786 24.2445 46.64 23.54C46.53 23.41 46.41 23.28 46.29 23.16L46.17 23.05C46.0274 22.9023 45.8772 22.7621 45.72 22.63C43.1429 20.5083 39.835 19.4847 36.51 19.78C36.51 19.56 36.51 19.44 36.51 19.44C35.8501 19.4642 35.2047 19.6401 34.6237 19.954C34.0428 20.2679 33.5419 20.7113 33.16 21.25C33.0167 21.4083 32.8926 21.5828 32.79 21.77C31.56 23.83 31 27 30 30.32L28.54 26.12H25.54C25.54 26.12 25.91 34.34 27.14 36.29C29.31 39.71 30.61 39.81 31.21 38.62C32.138 37.3539 32.9102 35.9807 33.51 34.53C34.38 37.12 35.18 39.19 34.07 42.74C19.77 49.74 18.48 51.88 20.18 70.95L23.99 73.06C25.74 58.49 25.74 57.2 33.87 52.74C29.68 57.85 29.66 64.05 30.87 77.28L34.6 79.4C37.81 62.22 37.09 61.56 42.16 57.08C45.66 53.97 48.67 52.85 49.36 48.9C49.7082 46.2661 49.5863 43.5913 49 41C49.5376 40.4331 49.9349 39.7481 50.16 39C50.44 35.42 50 29.84 48.14 25.94Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.13 71C10.79 75.8 16.89 78 23.94 73.11L20.13 71Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.79 77.28C24.66 80.11 25.24 86.05 34.6 79.4L30.79 77.28Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.390015 42.53V44.29L33.18 63.16L51.3 52.54",
    fill: "#DEDEDE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.390015 42.53V44.29L33.18 63.16L51.3 52.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L51.3 82.92V52.54L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 50.78L18.52 31.91L0.390015 42.53L33.18 61.41L51.3 50.78Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L31.98 92.94V62.56L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.74 46.41L28.11 53.82L19.49 48.87L32.13 41.47L40.74 46.41Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.74 48.44L28.11 55.85L19.49 50.9L32.13 43.49L40.74 48.44Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.59 47.64C32.99 49.36 35.36 55.08 41.66 48.9L38.59 47.64Z",
    fill: "#B1ADA2",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34 11.55C31.91 19.29 33.33 21.14 36.63 21.55V22.36C36.63 22.36 36.51 23.88 39.35 23.36C42.19 22.84 43.15 21.84 42.58 19.26C42.7 18.76 43.4 14.81 43.04 14.05C41.27 10.2 35.64 5.56001 34 11.55Z",
    fill: "#B1ADA2",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.31 14.39L33.89 10.74C34.89 16.34 40.53 17.45 40.53 17.45C40.53 17.45 40.81 15 42 15.18C43.19 15.36 43.41 17.03 42.15 18.93C42.0498 19.0444 41.98 19.1821 41.9467 19.3305C41.9135 19.4788 41.918 19.6332 41.9597 19.7793C42.0015 19.9255 42.0792 20.0589 42.1858 20.1674C42.2924 20.2758 42.4245 20.3558 42.57 20.4C42.57 20.4 46.47 17.89 44.85 12.04C43.91 8.62999 40.58 5.03999 34.22 8.85999C34.17 8.85999 29.21 10.19 33.31 14.39Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.52 26.12C32.52 22.68 22.58 16.55 25.52 26.12H28.52Z",
    fill: "#B1ADA2",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.09 33.94C50.2493 35.602 50.2727 37.2742 50.16 38.94C50.07 40.08 47.47 43.21 41.66 48.87L38.59 47.61C38.59 47.61 44.89 39.68 44.97 38.2C45.1 35.89 43.19 30.3 43.19 30.3",
    fill: "#252525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.09 33.94C50.2493 35.602 50.2727 37.2742 50.16 38.94C50.07 40.08 47.47 43.21 41.66 48.87L38.59 47.61C38.59 47.61 44.89 39.68 44.97 38.2C45.1 35.89 43.19 30.3 43.19 30.3",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.46 34.53C32.8602 35.9807 32.088 37.3539 31.16 38.62C30.56 39.81 29.26 39.71 27.09 36.29C25.86 34.34 25.49 26.12 25.49 26.12H28.49L30 30.32C30.31 29.32 30.58 28.37 30.83 27.44",
    fill: "#252525"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.46 34.53C32.8602 35.9807 32.088 37.3539 31.16 38.62V38.62C30.56 39.81 29.26 39.71 27.09 36.29C25.86 34.34 25.49 26.12 25.49 26.12H28.49L30 30.32C30.31 29.32 30.58 28.37 30.83 27.44",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.58 26.12C33.46 28.65 33.12 27.97 32.49 30.44C32.03 32.24 33.49 34.53 33.49 34.53",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudiante10);
export default __webpack_public_path__ + "static/media/Estudiante10.4427dc84c258507854c72e1e138f8472.svg";
export { ForwardRef as ReactComponent };